import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getReceiptInput,
  getReceiptsInput,
  ReceiptLiteModel,
  ReceiptModel,
} from './model';

export function useGetReceipts(
  input?: getReceiptsInput,
  options?: UseQueryOptions<ExtendedApiResult<ReceiptLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<ReceiptLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['receipts', input?.params],
      () =>
        QueryFetchFunction({
          url: 'receipts',
          params: input?.params,
        }),
      options,
    ),
    ReceiptLiteModel,
  );
}

export function useGetReceipt(
  input?: getReceiptInput,
  options?: UseQueryOptions<ApiResult<ReceiptModel>, ApiError>,
): UseQueryResult<ApiResult<ReceiptModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['receipts', input?.id],
      () =>
        QueryFetchFunction({
          url: `receipts/${input?.id}`,
        }),
      options,
    ),
    ReceiptModel,
  );
}

export function getReceiptsKey(input?: getReceiptsInput) {
  return ['receipts', input?.params];
}

export function getReceiptKey(input?: getReceiptInput) {
  return ['receipts', input?.id];
}
